import React from 'react';
import './../styles/Progress.css';

function Progress({ now, label, requirement }) {
  const progressBarStyle = {
    width: `${now}%`,
    height: '100%',
    backgroundColor: '#90EE90',
    // borderRadius: '20px 0 0 20px',
    transition: 'width 0.3s ease',
  };

  return (
    <div className="progress-bar-container">
      <div className="progress-bar" style={progressBarStyle} >
      <p className="progress-text">{requirement}</p>
      </div>
      {/* <span className="progress-label">{label} Complete</span> */}
    </div>
  );
}

export default Progress;
